import { ItemDetailsDto, ItemDetailsFeedSectionResp } from '@marketplace-web/domain/item-page-data'

export const getItemPageSimilarItemsPluginDto = (itemDto: ItemDetailsDto) => ({
  itemId: itemDto.id,
})

export const getServerItemPageSimilarItemsPluginDto = (feedDto: ItemDetailsFeedSectionResp) => ({
  itemId: feedDto.id,
})
